export function getOwsPath() {
    return '/owa';
}
